
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
export default {
components:{
Swiper,
Flexbox,
FlexboxItem,
Group,
Alert,
XInput,
XButton,
loadPage
},
data () {
return {
loopList: [],
show:false,
}
},
beforeMount (){
if(this.$router.history.current.path == "/convenientserver"){
document.title = "便民服务";
}
this.show_1 = false;
let obj = new Object();
obj.img = global.imgUrl + '/image/banner3.png'
let obj2 = new Object();
obj2.img = global.imgUrl + '/image/banner4.jpg'
this.loopList.push(obj)
this.loopList.push(obj2)
/*this.$http.get(global.host + 'users/personalCenter?').then(function(res){

},function(err){
console.log(err)
})*/
},
methods:{
change(){
console.log(1)
this.show = true;
}
}
}



// WEBPACK FOOTER //
// ./src/components/convenientComponents/server.vue